module.exports = {
  email: 'szcheng0702@gmail.com',

  // Giscus comments (GitHub Discussions backed).
  // See README "Blog comments" for how to fill these in.
  giscus: {
    repo: 'szcheng0702/v4-personal-website',
    repoId: '',
    category: 'Announcements',
    categoryId: '',
    mapping: 'pathname',
    reactionsEnabled: '1',
    inputPosition: 'top',
    lang: 'en',
  },

  socialMedia: [
    {
      name: 'GitHub',
      url: 'https://github.com/szcheng0702',
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/sizhu-lindsay-cheng',
    },
    {
      name: 'Twitter',
      url: 'https://twitter.com/lindsayscheng72',
    },
  ],

  navLinks: [
    // The first three anchor to numbered sections on the home page, so the
    // numbers shown in the nav match the numbers on those headings. The rest
    // are standalone pages.
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'Experience',
      url: '/#jobs',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
    {
      name: 'Projects',
      url: '/projects',
    },
    {
      name: 'Publications',
      url: '/publications',
    },
    {
      name: 'Blog',
      url: '/blog',
    },
  ],

  colors: {
    green: '#7c3aed',
    navy: '#faf9f7',
    darkNavy: '#f0eee9',
  },

  srConfig: (delay = 200, viewFactor = 0.25) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
